import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Logout, AccountCircle } from "@mui/icons-material";
import {
  AppBar,
  Toolbar,
  Grid,
  Box,
  useTheme,
  Button,
  Typography,
} from "@mui/material";
import i18n from "i18next";
import { selectCurrentToken } from "../../features/slices/authSlice";
import { logout } from "../../features/slices/authSlice";
import * as Constant from "../../features/constant";
import { useGetProfileQuery } from "../../features/api/userApiSlice";

import Image from "../common/Image";
import DropdownMenu from "../common/DropdownMenu";
import Drawer from "../common/Drawer";
import Backdrop from "../common/Backdrop";

import { useTranslation } from "react-i18next";
import LanguageDropdown from "../common/LanguageDropdown";
import { useGetLanguagesQuery } from "../../features/api/publicApiSlice";
import { lighten, darken, alpha } from "@material-ui/core";


const MobileHeader = ({ background }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const token = useSelector(selectCurrentToken);
  const apkUrl = `${window.location.origin}/${process.env.REACT_APP_APK}`;
  const [showPopup, setShowPopup] = useState(true);
  const signupLight = lighten(theme.palette.button.signup, 0.1);
  const signupDark = darken(theme.palette.button.signup, 0.05);
  const signupPulse = alpha(lighten(theme.palette.button.signup, 0.2), 0.4);
  const loginLight = lighten(theme.palette.button.login, 0.1);
  const loginDark = darken(theme.palette.button.login, 0.05);
  const logoutProfileItems = [
    {
      label: i18n.t("walletcard.logout"),
      icon: <Logout sx={{ height: 20 }} />,
      id: "logout-btn"
    },
  ];

  useEffect(() => {
    const handlePageShow = (event) => {
      if (event.persisted) {
        window.location.reload();
      }
    };
    window.addEventListener("pageshow", handlePageShow);
    return () => window.removeEventListener("pageshow", handlePageShow);
  }, []);

  const handleClose = () => {
    setShowPopup(false);
  };
  const handleButtonClick = () => {
    window.open(apkUrl, "_blank");
  };
  const {
    data: languages,
    isFetching: isLanguagesFetching,
    isLoading: isLanguagesLoading,
    isSuccess: isLanguagesSuccess,
  } = useGetLanguagesQuery({ prefetch: true });

  const {
    data: user,
    isFetching: isUserFetching,
    isLoading: isUserLoading,
  } = useGetProfileQuery({ prefetch: true });

  if (isUserFetching || isUserLoading) {
    return <Backdrop />;
  }

  const handleLogoutOnClick = (item) => {
    if (item?.label === i18n.t("walletcard.logout")) {
      dispatch(logout());
      navigate(Constant.getPath("/"));
    }
  };

  /*fancy gradient headers*/
  const gradient1 = process.env.REACT_APP_COLOR_HEADER_GRADIENT1?.trim();
  const gradient2 = process.env.REACT_APP_COLOR_HEADER_GRADIENT2?.trim();
  const headerImage = process.env.REACT_APP_MOBILE_HEADER_IMAGE?.trim();
  let headerColor;
  if (gradient1 && gradient2) {
    headerColor = `linear-gradient(to right, ${gradient1}, ${gradient2})`;
  } else if (headerImage) {
    headerColor = `url(${headerImage})`;
  } else {
    headerColor = theme.palette.header;
  }

  /*deposit and withdrawal button borders*/
  const buttonBorderColor = process.env.REACT_APP_COLOR_HEADER_DEPOWITHDRAW_BUTTONBORDER;
  /*fancy gradient deposit and withdrawal buttons*/
  const gradientButton = (index) => {
    const deposit1 = process.env.REACT_APP_COLOR_HEADER_DEPOSIT_GRADIENT1;
    const deposit2 = process.env.REACT_APP_COLOR_HEADER_DEPOSIT_GRADIENT2;
    const depositImg = process.env.REACT_APP_IMG_DEPOSIT;

    if (deposit1 && deposit2) {
      return `linear-gradient(to right, ${deposit1}, ${deposit2})`;
    }

    if (depositImg) {
      return `url(${depositImg})`;
    }

    return theme.palette.button.secondary.main;
  };

  return (
    <>
      <AppBar position="fixed" sx={{ marginBottom: '10px' }}>
        <Toolbar
          sx={{
            background: headerColor,
            backgroundSize: "cover",
            backgroundPosition: "center",
            height: 0,
          }}
        >
          <Grid container justifyContent="space-between" alignItems="center">
            {/*   <Grid item xs={4} alignSelf="center">
              <Drawer user={user?.result} />
            </Grid>*/}
            <Grid item xs={3} textAlign="left" sx={{ display: "flex" }}>
              <Box
                sx={{
                  maxWidth: "auto",
                  maxHeight: 50,
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <img
                  src={process.env.REACT_APP_MOBILE_HEADER_LOGO}
                  onClick={() => navigate(Constant.getPath("/"))}
                  alt={Constant.ALT_TAG_LOGO}
                  style={{
                    cursor: "pointer",
                    maxWidth: "120px",
                    maxHeight: "100%",
                    width: "auto",
                    height: "auto",
                  }}
                />
              </Box>
            </Grid>
            {token && (
              <Grid item xs={3} alignSelf="right" textAlign="right">
                <Button
                  variant="contained"
                  sx={{
                    minWidth: "54px",
                    height: "26px",
                    borderRadius: '3px', // Add border-radius for curved corners
                    background: gradientButton(),
                    border: buttonBorderColor ? `1px solid ${buttonBorderColor}` : "none",
                    padding: 0,
                    fontSize: "10px",
                    backgroundSize: "100% 100%",
                    position: "absolute",
                    marginRight: "125px",
                    marginTop: "6px",
                    right: "0"
                  }}
                  disableRipple
                  onClick={() =>
                    navigate(Constant.getPath("/profileWallet"), { state: { screen: "Deposit" } })
                  }
                >
                  {t("walletcard.deposit")}
                </Button>
                <Typography sx={{
                  color: process.env.REACT_APP_COLOR_ICON || "white",
                  marginTop: "8px",
                  right: "55px",
                  position: "absolute",
                  fontSize: "14px",
                }}>
                  {user?.result?.currentCredit}
                </Typography>
                <DropdownMenu
                  sxMenu={{
                    mt: "40px",
                  }}
                  items={logoutProfileItems}
                  handleOnClickEvent={handleLogoutOnClick}
                  icon={true}
                >
                  <AccountCircle sx={{ color: process.env.REACT_APP_COLOR_ICON || 'white' }} />
                </DropdownMenu>

              </Grid>
            )}
            {/* Mobile view login & register (below banner) */}
            {!token && (
              <Grid item xs={7} textAlign="right" sx={{ maxWidth: "75%" }}>
                <Box sx={{ display: "flex" }}>
                  <Image
                    width={25}
                    height={25}
                    sx={{
                      mr: "10px"
                    }}
                    src={process.env.REACT_APP_HEADER_LOGO + "/PROMOTION.png"}
                    onClick={() => {
                      navigate(Constant.getPath("/promotion"));
                    }}
                  />
                  <Button
                    variant="contained"
                    sx={{
                      backgroundImage: `linear-gradient(to bottom, ${loginLight} 50%, ${loginDark} 50%)`,
                      // backgroundImage: 'url(/assets/img/yellow_big.png)',
                      width: "40%", // Adjust the width as needed and consider the margin
                      marginRight: "8px", // Add margin to create a gap
                      borderRadius: '3px', // Add border-radius for curved corners
                      padding: 0,
                      fontSize: "12px",
                      backgroundSize: "100% 100%",

                    }}
                    disableRipple
                    onClick={() =>
                      navigate(Constant.getPath("/login"))
                    }
                  >
                    {t("home.login")}
                  </Button>
                  <Button
                    variant="contained"
                    sx={{
                      width: "40%",
                      borderRadius: '3px', // Add border-radius for curved corners
                      backgroundImage: `linear-gradient(to bottom, ${signupLight} 50%, ${signupDark} 50%)`,
                      // backgroundImage: 'url(/assets/img/red_big.png)',
                      padding: 0,
                      fontSize: "12px",
                      backgroundSize: "100% 100%",
                      transition: 'box-shadow 0.4s ease-in-out',
                      '&:hover': {
                        boxShadow: `0 0 20px ${signupPulse}`, // Adjust hover shadow color and size as needed
                        backgroundImage: `linear-gradient(to bottom, ${signupLight} 50%, ${signupDark} 50%)`,
                      },
                      '@keyframes shadow-pulse': {
                        '0%': {
                          boxShadow: `0 0 0 5px ${signupPulse}`, // Adjust initial shadow color and size as needed
                        },
                        '80%': {
                          boxShadow: `0 0 5px ${signupPulse}`, // Adjust pulse shadow color and size as needed
                        },
                      },
                      '@keyframes vibration': {
                        '0%': {
                          transform: 'translateX(0)',
                        },
                        '25%': {
                          transform: 'translateX(-2px)',
                        },
                        '50%': {
                          transform: 'translateX(2px)',
                        },
                        '75%': {
                          transform: 'translateX(-2px)',
                        },
                        '100%': {
                          transform: 'translateX(0)',
                        },
                      },
                      animation: 'shadow-pulse 1s infinite alternate, vibration 0.7s infinite', // Combine pulse and vibration animations

                    }}
                    disableRipple
                    onClick={() =>
                      navigate(Constant.getPath("/register"))
                    }
                  >
                    {t("home.signup")}
                  </Button>
                  <LanguageDropdown languages={languages?.result} />

                </Box>
              </Grid>
            )}
          </Grid>
        </Toolbar>
      </AppBar>
    </>
  );
};

MobileHeader.propTypes = {
  background: PropTypes.string,
};

MobileHeader.defaultProps = {
  background: "",
};

export default MobileHeader;
